import { smb_fetch, getAgpApiUrl } from '@/api/operator/fetch';
import { TRACK_SPLITOR, PROVINCE_TYPE_MAP } from '../config';

const DEFAULT_CACHE = 1000 * 60 * 60;

export const addCommonParams = (params: any) => {
  const { period, track, agencyRangeType, ...rest } = params;
  const [year, quarter] = period?.split('_Q') || [];
  const agencyRangeParams = agencyRangeType !== undefined ? {
    is_yi_dai: agencyRangeType,
  } : {};
  if (track) {
    const [mainTrack, subTrack, province] = track.split(TRACK_SPLITOR);
    if (province) {
      return {
        year,
        quarter,
        ...rest,
        ...agencyRangeParams,
        skill_type: subTrack && !PROVINCE_TYPE_MAP[subTrack] ? `${mainTrack}_${subTrack}` : mainTrack,
        province_manage: province,
      };
    }
    return {
      year,
      quarter,
      ...rest,
      ...agencyRangeParams,
      skill_type: subTrack ? `${mainTrack}_${subTrack}` : mainTrack,
    };
  }
  return {
    year,
    quarter,
    ...rest,
  };
};

export const getAgentGroup = () => {
  const url = getAgpApiUrl('eservice/grow_up_center', 'get_agent_group');
  return smb_fetch(url, {
    method: 'POST',
    isCache: true,
    cacheMaxAge: DEFAULT_CACHE,
    contentType: 'application/json',
    data: {},
  }, false, false);
};

export const getEnabledTrackList = (data: any) => {
  const url = getAgpApiUrl('eservice/grow_up_center', 'track_list');
  return smb_fetch(url, {
    method: 'POST',
    isCache: true,
    cacheMaxAge: DEFAULT_CACHE,
    contentType: 'application/json',
    data: addCommonParams(data),
  }, false, false);
};

export const getAbilitySummaryData = (data: any) => {
  const url = getAgpApiUrl('eservice/grow_up_center', 'summary');
  return smb_fetch(url, {
    method: 'POST',
    isCache: true,
    cacheMaxAge: DEFAULT_CACHE,
    contentType: 'application/json',
    data: addCommonParams(data),
  }, true, false);
};

export const getAbilityDetailData = (data: any) => {
  const url = getAgpApiUrl('eservice/grow_up_center', 'ability_detail');
  return smb_fetch(url, {
    method: 'POST',
    isCache: true,
    cacheMaxAge: DEFAULT_CACHE,
    contentType: 'application/json',
    data: addCommonParams(data),
  }, true, false);
};

export const getAbilityTrendData = (data: any) => {
  const url = getAgpApiUrl('eservice/grow_up_center', 'score_history_list');
  return smb_fetch(url, {
    method: 'POST',
    isCache: true,
    cacheMaxAge: DEFAULT_CACHE,
    contentType: 'application/json',
    data: addCommonParams(data),
  }, false, false);
};

export const getRankData = (data: any) => {
  const url = getAgpApiUrl('eservice/grow_up_center', 'ranking_list');
  return smb_fetch(url, {
    method: 'POST',
    isCache: true,
    cacheMaxAge: DEFAULT_CACHE,
    contentType: 'application/json',
    data: addCommonParams(data),
  }, false, false);
};

export const getAbilityClientList = (data: any) => {
  const url = getAgpApiUrl('eservice/grow_up_center', 'ability_short_advertiser_name_list');
  return smb_fetch(url, {
    method: 'POST',
    isCache: true,
    cacheMaxAge: DEFAULT_CACHE,
    contentType: 'application/json',
    data: addCommonParams(data.data),
  }, true, false);
};

export const getOperateAbilityClientList = (data: any) => {
  const url = getAgpApiUrl('eservice/grow_up_center', 'operate_ability_short_advertiser_name_list');
  return smb_fetch(url, {
    method: 'POST',
    isCache: true,
    cacheMaxAge: DEFAULT_CACHE,
    contentType: 'application/json',
    data: addCommonParams(data.data),
  }, true, false);
};

export const getIllegalSummary = (data: any) => {
  const url = getAgpApiUrl('eservice/grow_up_center', 'illegal_summary');
  return smb_fetch(url, {
    method: 'POST',
    isCache: true,
    cacheMaxAge: DEFAULT_CACHE,
    contentType: 'application/json',
    data: addCommonParams(data),
  }, false, false);
};

export const getIllegalClientList = (data: any, isShowError = true) => {
  const url = getAgpApiUrl('eservice/grow_up_center', 'illegal_entity_list');
  return smb_fetch(url, {
    method: 'POST',
    isCache: true,
    cacheMaxAge: DEFAULT_CACHE,
    contentType: 'application/json',
    data: addCommonParams(data.data),
  }, isShowError, false);
};

export const getMedicalAuditList = (data: any) => {
  const url = getAgpApiUrl('eservice/grow_up_center', 'medical_audit_list');
  return smb_fetch(url, {
    method: 'POST',
    isCache: true,
    cacheMaxAge: DEFAULT_CACHE,
    contentType: 'application/json',
    data: addCommonParams(data.data),
  }, true, false);
};

export const getOperateAbilityDetailData = (data: any) => {
  const url = getAgpApiUrl('eservice/grow_up_center', 'operate_ability_detail');
  return smb_fetch(url, {
    method: 'POST',
    isCache: true,
    cacheMaxAge: DEFAULT_CACHE,
    contentType: 'application/json',
    data: addCommonParams(data),
  }, true, false);
};

export const getIllegalTrendData = (data: any) => {
  const url = getAgpApiUrl('eservice/grow_up_center', 'illegal_trend');
  return smb_fetch(url, {
    method: 'POST',
    isCache: true,
    cacheMaxAge: DEFAULT_CACHE,
    contentType: 'application/json',
    data: addCommonParams(data),
  }, false, false);
};

export const getTalentCertList = (data: any) => {
  const url = getAgpApiUrl('eservice/grow_up_center', 'talent_cert_list');
  return smb_fetch(url, {
    method: 'POST',
    isCache: true,
    cacheMaxAge: DEFAULT_CACHE,
    contentType: 'application/json',
    data: addCommonParams(data.data),
  }, false, false);
};

export const getRegionProvinceList = (data: any) => {
  const url = getAgpApiUrl('eservice/grow_up_center', 'agent_province_enum');
  return smb_fetch(url, {
    method: 'POST',
    isCache: true,
    cacheMaxAge: DEFAULT_CACHE,
    contentType: 'application/json',
    data: addCommonParams(data),
  }, false, false);
};

export const getSearchProvinceList = (data: any) => {
  const url = getAgpApiUrl('eservice/grow_up_center', 'search_province_enum');
  return smb_fetch(url, {
    method: 'POST',
    isCache: true,
    cacheMaxAge: DEFAULT_CACHE,
    contentType: 'application/json',
    data: addCommonParams(data),
  }, false, false);
};

export const getIndustryTeamList = () => {
  const url = getAgpApiUrl('eservice/grow_up_center', 'team_list');
  return smb_fetch(url, {
    method: 'POST',
    isCache: true,
    cacheMaxAge: DEFAULT_CACHE,
    data: {},
  }, false, false);
};

export const getRuyiIndustryList = () => {
  const url = getAgpApiUrl('eservice/grow_up_center', 'ru_yi_industry_list');
  return smb_fetch(url, {
    method: 'POST',
    isCache: true,
    cacheMaxAge: DEFAULT_CACHE,
    data: {},
  }, false, false);
};

export const getCategoryList = () => {
  const url = getAgpApiUrl('eservice/grow_up_center', 'list_cate');
  return smb_fetch(url, {
    method: 'POST',
    isCache: true,
    cacheMaxAge: DEFAULT_CACHE,
    data: {},
  }, false, false);
};

export const getOptimizationGoalList = () => {
  const url = getAgpApiUrl('eservice/grow_up_center', 'og_list');
  return smb_fetch(url, {
    method: 'POST',
    isCache: true,
    cacheMaxAge: DEFAULT_CACHE,
    data: {},
  }, false, false);
};
